import { getQueryStr, appendQueryStr } from '../base/mbase.js';
import {  hexColor2GrayColor } from "../base/mbase"
import { FromIdMap, SharePositionID, ShareActionID } from '../config/enums.js';

let shareIdInfoCache;

const getShareId = async () => {
    if (shareIdInfoCache) {
        return shareIdInfoCache;
    }
    if( WXGAME?.xhrCallCgi ) {
        return new Promise((resolve, reject) => {
            WXGAME.xhrCallCgi('https://game.weixin.qq.com/cgi-bin/gamecenterwap/getshareid', {},
            (result) => {
                if (result.errcode === 0 && result.data?.share_id) {
                    shareIdInfoCache = {
                        share_id: result.data.share_id,
                        origin_share_id: getQueryStr('origin_share_id') || getQueryStr('share_id') || '',
                    };
                    resolve(shareIdInfoCache)
                }else {
                    resolve({
                        share_id: '',
                        origin_share_id: '',
                    })
                }
            }, () => {
                resolve({
                    share_id: '',
                    origin_share_id: '',
                })
            })
        })

    }
    return {
        share_id: '',
        origin_share_id: '',
    };
};

const reportShareAction = (base) => {
    const ext = {};
    if (base.share_id) {
      ext.share_id = base.share_id;
    }
    if (base.origin_share_id) {
      ext.origin_share_id = base.origin_share_id;
    }
    WXGAME?.Report11332.report({
        iSceneId: 34,
        iUIArea: 3443,
        iPositionId: base.pid,
        iActionId: base.aid,
        sExternInfo: ext,
    });
};

async function beforeInvoke (act, opt, cbk) {
    if (act === 'sendAppMessage' || act === 'shareTimeline') {
        const shareIdInfo = await getShareId();
        reportShareAction({
            pid: SharePositionID.PAGE,
            aid: act === 'sendAppMessage' ? ShareActionID.SENDAPPMESSAGE: ShareActionID.SENDTIMELINE,
            ...shareIdInfo,
        });
        // 分享场景注入from_id
        if (opt?.link && !getQueryStr('from_id', opt.link)) {
            opt.link = appendQueryStr(opt.link, 'from_id', FromIdMap[act]);
        }
        if( shareIdInfo.share_id && opt.link ) {
            opt.link = appendQueryStr(opt.link, 'share_id', shareIdInfo.share_id);
        }
        if( shareIdInfo.origin_share_id && opt.link ) {
            opt.link = appendQueryStr(opt.link, 'origin_share_id', shareIdInfo.origin_share_id);
        }
    } else if (act === 'shareCustomContent') {
        // 页面自定义分享场景注入from_id
        if (opt?.friend?.link && !getQueryStr('from_id', opt.friend.link)) {
            opt.friend.link = appendQueryStr(opt.friend.link, 'from_id', FromIdMap['sendAppMessage']);
        }
        if (opt?.timeline?.link && !getQueryStr('from_id', opt.timeline.link)) {
            opt.timeline.link = appendQueryStr(opt.timeline.link, 'from_id', FromIdMap['shareTimeline']);
        }
    } else if (act === 'sendGameNameCard' ) {
        const shareIdInfo = await getShareId();
        reportShareAction({
            pid: SharePositionID.PAGE,
            aid: ShareActionID.SENDAPPMESSAGE,
            ...shareIdInfo,
        });
        // 游戏名片分享场景注入from_id
        if (opt?.link && !getQueryStr('from_id', opt.link)) {
            opt.link = appendQueryStr(opt.link, 'from_id', FromIdMap[act]);
        }
        if (opt?.card_link && !getQueryStr('from_id', opt.card_link)) {
            opt.card_link = appendQueryStr(opt.card_link, 'from_id', FromIdMap[act]);
        }
        if( shareIdInfo.share_id ) {
            if( opt?.link ) {
                opt.link = appendQueryStr(opt.link, 'share_id', shareIdInfo.share_id);
            }
            if( opt?.card_link ) {
                opt.card_link = appendQueryStr(opt.card_link, 'share_id', shareIdInfo.share_id);
            }
        }
        if( shareIdInfo.origin_share_id && opt.link ) {
            if( opt?.link ) {
                opt.link = appendQueryStr(opt.link, 'origin_share_id', shareIdInfo.origin_share_id);
            }
            if( opt?.card_link ) {
                opt.card_link = appendQueryStr(opt.card_link, 'origin_share_id', shareIdInfo.origin_share_id);
            }
        }
    }else if( act === 'setNavigationBarColor' ) {
        if( WXGAME.GlobalConfig.ui?.isFilterGray?.() && opt && opt.color) {
            opt.color = hexColor2GrayColor(opt.color);
        }
        WXGAME?.setCustomNavigation?.setColor(opt);
    }else if( act === 'getGameData' ) {
        if( window?.WXGAME?.GlobalConfig.cache?.needRemoveCache(opt.key) ) {
            return {
                mock: true,
                response: {
                    value: '',
                    err_msg: "getData:ok"
                }
            }
        }
    }else if( act === 'setGameData' ) {
        let expireConfig = window?.WXGAME?.GlobalConfig.cache?.getExpireCacheConfig(opt.key);
        if( expireConfig?.expire_time ) {
            opt.expireTime = String(expireConfig.expire_time)
        }
    }
}

export {
    beforeInvoke
}